import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Form, Input, DatePicker, Select, message } from "antd";
import moment from "moment";
import MedicalService from "../../../../Services/MedicalHistoryService";

function AddSurgicalHistory(props) {
  const [surgicalValue, setSurgicalValue] = useState();
  const [isLoading,setIsLoading] = useState(false);
  const [givenDate,setGivenDate] = useState();
  const [manualSurg, setManualSurg] = useState('');
  const formRef = useRef();
  const InputRef = useRef();
  
  useEffect(() => {
    if (manualSurg && InputRef.current) InputRef.current.focus();
  }, [manualSurg]);

  const handleCancel = () => {
    formRef.current.resetFields();
    setGivenDate('');
    props.onClose();
  };

  const handleDate = (date, dateString) => {
    if(dateString){
    const constructedTime = dateString + " " + "00:00:00";
    setGivenDate(constructedTime);
    }
    else{
      setGivenDate('');
    }
  }

  const disabledFutureDate = (current) => {
    return current && current > moment().endOf("day");
  };

  const handlehealthChange = (value) => {
    setSurgicalValue(value);
  };
  const surgicalProcedures = [
    { name: "Cholecystectomy (gall bladder removal)", value: "Cholecystectomy (gall bladder removal)" },
    { name: "Appendectomy (appendix removal)", value: "Appendectomy (appendix removal)" },
    { name: "Vasectomy (vas deferens)", value: "Vasectomy (vas deferens)" },
    { name: "Cardiac surgery (open heart)", value: "Cardiac surgery (open heart)" },
    { name: "Bypass surgery - stent in the heart", value: "Bypass surgery - stent in the heart" },
    { name: "Hysterectomy (uterus removal)", value: "Hysterectomy (uterus removal)" },
    { name: "Hernia surgery", value: "Hernia surgery" },
    { name: "Angioplasty", value: "Angioplasty" },
    { name: "Caesarean section", value: "Caesarean section" },
    { name: "Knee replacement", value: "Knee replacement" },
    { name: "Spine Surgery", value: "Spine Surgery" },
    { name: "Cataract surgery", value: "Cataract surgery" },
    { name: "Laser surgery for retina (eye)", value: "Laser surgery for retina (eye)" },
    { name: "Hip replacement surgery", value: "Hip replacement surgery" },
    { name: "Cancer surgery", value: "Cancer surgery" },
    { name: "Ear surgery", value: "Ear surgery" },
    { name: "Tonsillectomy (tonsil removal)", value: "Tonsillectomy (tonsil removal)" },
    { name: "Others", value: "Others" }
  ];

  const onFinish = async(e) => {
    e.preventDefault();
    setIsLoading(true);
    const currDate = new Date().toISOString();
    const date = currDate.split('T')[0];
    const time = currDate.split('T')[1].slice(0, 8);
    const constructedTime = date + " " + time;

    const loginObj = sessionStorage.getItem("login_result");
    const userData = loginObj ? JSON.parse(loginObj) : null;

    if(!(surgicalValue || manualSurg) || !givenDate){
      message.error("Please fill all fields");
      setIsLoading(false);
      return;
    }
    let payload = {
      account_Id:props.selectedPatient?.account_Id,
      clinic_Id:props.selectedPatient?.clinic_Id,
      userId:props.selectedPatient?.userId,
      createdDate: constructedTime,
      givenDate: givenDate,
      createdBy: userData.user.userId,
      modifiedBy: userData.user.userId,
      status: 1,
      patientId: props.selectedPatient?.patientId,
      surgicalInfo: surgicalValue?surgicalValue:manualSurg,
      description: null,
      patientBloodGroup: "",
      patientDob: "",
      patientEmail: "",
      patientName: "",
      modifiedDate: constructedTime,
      fromDate: givenDate,
      toDate: givenDate,
    };
    
    MedicalService.AddSurgicalHistory(payload)
      .then((result) => {
        formRef.current.resetFields();
        props.handleLatestUpdate(result.data);
        setIsLoading(false);
        props.onClose();
      })
      .catch((error) => {
        console.log(error);
        setIsLoading(false);
      });
  };

  const handleSurgSearch = (value) => {
    const isPresent = surgicalProcedures.findIndex((item) => item.name.includes(value));
    if (isPresent === -1) {
      setManualSurg(value);
    }
  }

  const handleManualSurg = (e) => {
    const value = e.target.value;
    if (value) {
      setManualSurg(value);
    }
    else {
      setManualSurg('');
    }
  }

  return (
    <div>
      <Form
        name="basic"
        labelCol={{
          span: 24,
        }}
        wrapperCol={{
          span: 24,
        }}
        ref={formRef}
        disabled={isLoading}
      >
        <Row gutter={20}>
          <Col className="gutter-row" span={12}>
            <Form.Item
              label={
                <span className="font-medium">
                  Surgical History{" "}
                  <span style={{ color: "#FF000F" }}>*</span>
                </span>
              }
              name="pastInfo"
            >
              <Select
                style={{ width: "100%" }}
                showSearch
                onSearch={handleSurgSearch}
                onChange={handlehealthChange}
                placeholder="Select"
                // value={surgicalValue}
                options={surgicalProcedures}
                filterOption={(input, option) =>
                  option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
                }
                className={`${manualSurg ? 'hidden' : 'block'}`}
                allowClear
              />
               <Input type="text"
                className={`${manualSurg ? 'block' : 'hidden'}`}
                value={manualSurg}
                onChange={(e) => handleManualSurg(e)}
                ref={InputRef}
              />
            </Form.Item>
          </Col>

          <Col className="gutter-row" span={12}>
            <Form.Item label={<span className="font-medium">Date{" "}<span style={{ color: "#FF000F" }}>*</span></span>} name="givenDate">
              <DatePicker
                style={{ width: "100%" }}
                placeholder="Select"
                format="YYYY-MM-DD"
                onChange={handleDate}
                disabledDate={disabledFutureDate}
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <Col className="gutter-row" span={24}>
        <div className="flex items-center w-full justify-end my-5">
          <button
            onClick={handleCancel}
            disabled={isLoading}
            className="border-brand-primaryColor border rounded-md bg-white text-brand-primaryColor text-sm px-6 py-1.5 disabled:cursor-not-allowed disabled:opacity-50"
          >
            Cancel
          </button>
          <button disabled={isLoading} onClick={onFinish} className="bg-brand-primaryColor rounded-md px-5 py-1.5 text-white text-sm ml-3 disabled:cursor-not-allowed disabled:opacity-50">
            Submit
          </button>
        </div>
      </Col>
    </div>
  );
}

export default AddSurgicalHistory;
